import appImg1 from 'assets/img/screenshot/ic-screenshot-1.png';
import appImg2 from 'assets/img/screenshot/ic-screenshot-2.png';
import appImg3 from 'assets/img/screenshot/ic-screenshot-3.png';
import appImg4 from 'assets/img/screenshot/ic-screenshot-4.png';
import appImg5 from 'assets/img/screenshot/ic-screenshot-5.png';
import appImg6 from 'assets/img/screenshot/ic-screenshot-6.png';

// import c1 from 'assets/img/ic_text_translation.png';
// import c2 from 'assets/img/ic_voice_translation.png';
// import c3 from 'assets/img/ic_camera_translation.png';
// import c4 from 'assets/img/ic_offline_translation.png';
// import c5 from 'assets/img/ic_keyboard_translation.png';

export const homeCardList = [
  { title: 'Timers VPN connect', desc: 'Set a time limit for your VPN connection, ensuring that you use the VPN for a specified duration for added security and preventing sensitive information from being exposed.', img: appImg2 },
  { title: 'Special Servers for Streaming and Game', desc: 'Optimized dedicated servers designed specifically for streaming, helping users bypass geographical restrictions and enjoy high-quality, stable global content.', img: appImg3 },
  { title: 'Custom Routing Table', desc: 'Provides customizable routing settings, allowing users to finely control network traffic to ensure optimal performance and security, catering to different online needs.', img: appImg4, },
  { title: 'Global Servers', desc: 'A wide range of global servers offering various connection options for faster and more secure VPN access worldwide.', img: appImg5, },
]